import { screenSizeIsConsideredMobile, useScreenSize } from "@/lib/common/ScreenSizeContext";
import { useLayoutEffect, useRef, useState, type FC, type PropsWithChildren } from "react";

export interface HeightExpanderProps extends PropsWithChildren {
	className?: string;
	fixed?: boolean;
}

export const HeightExpander: FC<HeightExpanderProps> = props => {
	const {
		children,
		className,
		fixed = false
	} = props;

	const ref = useRef<HTMLDivElement>(null);
	const [remainingHeight, setRemainingHeight] = useState(0);
	const [windowHeight, setWindowHeight] = useState(window.innerHeight);
	const screenSize = useScreenSize();

	useLayoutEffect(() => {
		const handleResize = () => setWindowHeight(window.innerHeight);
		window.addEventListener("resize", handleResize);

		return () => window.removeEventListener("resize", handleResize);
	}, []);

	useLayoutEffect(() => {
		if (!ref.current) {
			return;
		}

		setRemainingHeight(windowHeight - ref.current.getBoundingClientRect().y);
	});

	if (screenSizeIsConsideredMobile(screenSize)) {
		return (
			<>
				{children}
			</>
		);
	}

	return (
		<div ref={ref} style={fixed ? { height: remainingHeight, overflow: "hidden" } : { minHeight: remainingHeight }} className={className}>
			{children}
		</div>
	);
};
